import { storage } from '../../../js/utils/storage.js';

const FEATURE_MESSAGE_COUNT_KEY = 'hangout_user_message_count';

const isFreeLoggedInUser = () => {
    const userData = storage.get('userData');
    return !!(userData && userData.isLoggedIn && (!userData.current_tier || userData.current_tier === 'free'));
};

const showDismissibleHangoutInfoToast = async (notificationKey, fallbackMessage) => {
    if (!isFreeLoggedInUser()) return;

    const notificationSystem = (await import('../../utils/UnifiedNotificationSystem.js')).default;
    const {
        areHangoutFeatureNotificationsEnabled,
        isFeatureNotificationDismissed,
        dismissFeatureNotification
    } = await import('../../utils/feature-notifications.js');
    if (!areHangoutFeatureNotificationsEnabled()) return;
    if (await isFeatureNotificationDismissed(notificationKey)) return;

    const langResolver = /** @type {any} */ (window)['getCurrentLanguage'];
    const lang = typeof langResolver === 'function' ? langResolver() : 'en';
    const message = window.translations?.[lang]?.hangout?.notifications?.[notificationKey] || fallbackMessage;
    const notification = notificationSystem.info(message, {
        duration: 0,
        closable: false,
        position: 'top-right',
        onClick: async () => {
            await dismissFeatureNotification(notificationKey);
            notificationSystem.remove(notification);
        }
    });
};

const FEATURE_TOASTS_BY_COUNT = {
    2: async () => {
        await showDismissibleHangoutInfoToast(
            'language_feature',
            'Change her language? Go to the character menu in ⚙️ settings'
        );
        setTimeout(() => {
            void showDismissibleHangoutInfoToast(
                'resize_move',
                'You can resize the character image and move the bubble, try it, click on them!'
            );
        }, 2000);
    },
    3: async () => {
        const { showMoanFeatureNotification } = await import('../../../hangout.js');
        showMoanFeatureNotification();
    },
    4: () => showDismissibleHangoutInfoToast(
        'gallery_feature',
        'Not happy with an image? Click the <i class="fas fa-user"></i> gallery menu to remove an image from the decision poll for that character'
    )
};

export const maybeShowHangoutFeatureToasts = () => {
    const messageCount = parseInt(sessionStorage.getItem(FEATURE_MESSAGE_COUNT_KEY) || '0', 10) + 1;
    sessionStorage.setItem(FEATURE_MESSAGE_COUNT_KEY, String(messageCount));

    const showToast = FEATURE_TOASTS_BY_COUNT[messageCount];
    if (!showToast) return;

    setTimeout(async () => {
        try {
            await showToast();
        } catch (error) {
            console.warn('[Hangout] Failed to show feature notification:', error);
        }
    }, 500);
};
